import React from 'react';
import {
  RiFacebookLine,
  RiInstagramLine,
  RiTwitterLine,
  RiLinkedinLine,
  RiMapPin2Line,
  RiPhoneLine,
  RiMailLine,
  RiArrowUpLine,
  RiCloseLine,
  RiMenuLine,
  RiAwardLine,
  RiHotelLine,
  RiCustomerService2Line,
  RiTeamLine,
  RiContactsLine,
  RiTimeLine,
  RiAuctionLine,
  RiHomeHeartLine,
  RiCalendarEventLine,
  RiCompassDiscoverLine
} from 'react-icons/ri';

// Definisco le icone con una factory function
const createIconComponent = (IconComponent: any): React.FC => {
  return () => React.createElement(IconComponent, { size: 20 });
};

// Creo componenti wrapper per le icone usando la factory
export const FacebookIcon = createIconComponent(RiFacebookLine);
export const InstagramIcon = createIconComponent(RiInstagramLine);
export const TwitterIcon = createIconComponent(RiTwitterLine);
export const LinkedinIcon = createIconComponent(RiLinkedinLine);
export const MapPinIcon = createIconComponent(RiMapPin2Line);
export const PhoneIcon = createIconComponent(RiPhoneLine);
export const MailIcon = createIconComponent(RiMailLine);
export const ArrowUpIcon = createIconComponent(RiArrowUpLine);
export const CloseIcon = createIconComponent(RiCloseLine);
export const MenuIcon = createIconComponent(RiMenuLine);
export const AwardIcon = createIconComponent(RiAwardLine);
export const HotelIcon = createIconComponent(RiHotelLine);
export const CustomerServiceIcon = createIconComponent(RiCustomerService2Line);
export const TeamIcon = createIconComponent(RiTeamLine);
export const ContactsIcon = createIconComponent(RiContactsLine);
export const TimeIcon = createIconComponent(RiTimeLine);
export const AuctionIcon = createIconComponent(RiAuctionLine);
export const HomeIcon = createIconComponent(RiHomeHeartLine);
export const EventIcon = createIconComponent(RiCalendarEventLine);
export const ExperienceIcon = createIconComponent(RiCompassDiscoverLine); 